<template>
    <v-list-item class="px-0">
        <v-list-item-avatar
            color="white"
            size="70"
            class="mr-1 mr-md-3"
            style="border-radius: 0"
        >
            <v-img
                v-if="bankLogo"
                alt="sender avatar image"
                style="border-radius: 0"
                height="40"
                max-width="120"
                :src="bankLogo"
            />
            <v-icon
                v-else
                color="primary accent-4"
                v-text="'mdi-bank'"
            />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-if="bank" v-text="bank.Name"></v-list-item-title>
          <v-list-item-subtitle v-text="`Account number: ${account_number}`"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="removable" class="ml-1 ml-md-3 pt-4">
            <v-btn icon @click="removeAccount">
                <v-icon color="red lighten-1">
                    mdi-minus-circle
                </v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>

<script>

import FlutterwaveService from '../../../services/FlutterwaveService';

export default {
    props: getProps(),
    data() {
        return {
            account_number: null,
            bank: null,
            bank_code: null,
            banks: [],
        };
    },
    watch: getWatch(),
    mounted,
    methods: getMethods(),
    computed: {
        bankLogo() {
            const country = this.$store.state.user.country_abbreviation.toLowerCase();
            const bankCode = this.bank_code;

            if (!bankCode) {
                return null;
            }

            return `/images/banks/${country}/${bankCode}.png`;
        }
    }
};

function getProps() {
    return {
        input: {
            type: Object,
            default: () => ({}),
        },
        removable: {
            type: Boolean,
            default: true,
        },
        abbreviation: String,
    };
}

function getWatch() {
    return {
        input: function(data) {
            this.setData(data);
        },
    };
}

function mounted() {
    this.loadBanks(this.abbreviation).then(() => {
        this.setData(this.input);
    });
}

function getMethods() {
    return {
        loadBanks(abbreviation) {
            this.$emit('loading');
            return FlutterwaveService.getBanksByCountry(abbreviation)
                .then((banks) => {
                    if (banks.length === 0) {
                        this.$swal({
                            type: 'error',
                            title: 'No banks found',
                        });
                    } else {
                        this.banks = banks;
                    }
                    this.$emit('loaded');
                })
                .catch((err) => {
                    this.$emit('loaded');
                    this.$swal({
                        type: 'error',
                        title: 'Error loading banks',
                    });
                });
        },
        setData(data) {
            this.bank_code = data.bank_code;
            this.account_number = data.account_number;
            this.bank = this.banks.find((item) => item.Code === this.bank_code);
        },
        removeAccount() {
            this.$emit('remove');
        },
    };
}
</script>
